export const analyticsEndpoints = (builder) => {
  return {
    getOrdersData: builder.mutation({
      query: (ts) => ({
        url: `/analytics/orders?from=${ts[0]}&to=${ts[1]}`,
        method: 'get',
      }),
    }),
    getLorasData: builder.mutation({
      query: (ts) => ({
        url: `/analytics/topLoras?from=${ts[0]}&to=${ts[1]}`,
        method: 'get',
      }),
    }),
    getSubscriptionUsage: builder.mutation({
      query: () => ({
        url: `/analytics/usage`,
        method: 'get',
      }),
    }),
    getRevenuecat: builder.mutation({
      query: () => ({
        url: `/analytics/revenuecat`,
        method: 'get',
      }),
    }),
  };
};
